import { html, View } from 'rune-ts';
import klass from '@services/MarppleShop/renderApp/pages/Main/views/DomainBanner/DomainBanner.module.scss';
import { ChevronRightIcon } from '@services/MarppleShop/shared/components/atoms/Icon/foundation_icons.ts';

export interface BannerArrowButtonProps {
  direction?: 'left' | 'right';
}

export interface DomainBannerNavigationData {
  prev_enable: boolean;
  next_enable: boolean;
}

export class BannerArrowButton extends View<BannerArrowButtonProps> {
  override template() {
    return html`
      <button
        class="${klass.button_arrow} ${this.data.direction} ${this.data.direction === 'left'
          ? klass.left
          : ''}"
        type="button"
      >
        ${ChevronRightIcon({ klass: klass.arrow })}
      </button>
    `;
  }
}

export class NavigateHandleEvent extends CustomEvent<{
  direction: 'prev' | 'next';
}> {}

export class DomainBannerNavigationView extends View<DomainBannerNavigationData> {
  override template() {
    const navigation = this.data;
    return html` <div class="navigation ${klass.navigation}">
      ${navigation.prev_enable ? new BannerArrowButton({ direction: 'left' }) : ''}
      ${navigation.next_enable ? new BannerArrowButton({ direction: 'right' }) : ''}
    </div>`;
  }

  protected override onRender() {
    this.delegate('click', BannerArrowButton, (_e, targetView) => {
      this.dispatchEvent(NavigateHandleEvent, {
        bubbles: true,
        detail: {
          direction: targetView.data.direction === 'left' ? 'prev' : 'next',
        },
      });
    });
  }
}
